import axios from 'axios';
import { PaginatedCategories } from '../types';

export const fetchCategoriesList = async (): Promise<PaginatedCategories> => {
  return (await axios.get(`/v1/category`)).data;
};
